export const TOKEN_KEY = 'authToken';
export const DATA_KEY = 'userData';
export const VUEX_PERSIST_KEY = 'vuex';

export const MUTATION = {
  SET_DATA: 'setData',
  SET_TOKEN: 'setToken',
};

export const ACTION = {
  LOGIN: 'login',
  LOGIN_VIA_CONNECT: 'loginViaConnect',
  SAVE: 'save',
  LOGOUT: 'logout',
};

export const GETTER = {
  AUTHENTICATED: 'authenticated',
  FULL_NAME: 'fullName',
  FORMAL_NAME: 'formalName',
  CONTACT_PHOTO: 'contactPhoto',
  INITIALS: 'initials',
  USER_TYPE: 'userType',
};
